import React, { useEffect, useState } from 'react';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import ScheduleComponent from '../schedule/ScheduleComponent';
import { getUserName, isLoggedIn } from '../../helper/access';
import PopupModal from './PopupModal';
import Login from './Login';
import JoinMeetingComponent from '../schedule/JoinMeetingComponent';


const Navigationbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [showSchedulePop, setShowSchedulePop] = useState(false);
  const [showJoinMeetingPop, setShowJoinMeetingPop] = useState(false);
  const [loggedName, setLoggedInName] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);


  useEffect(() => {
    if (localStorage.getItem("user")) {
      let User = JSON.parse(localStorage.getItem("user"));
      setLoggedInName(User?.name || "")
    }else{
      setLoggedInName("")
    }
  }, [localStorage.getItem("user")]);


  const handleLinkClick = (label) => {
    setActiveLink(label);
    closeSidebar();
  };
  const closeSchedulePopup = () => {
    setShowSchedulePop(false);
  }
  const closeJoinMeetingPop = () => {
    setShowJoinMeetingPop(false);
  }

  return (
    <nav className="navbar customNavbar">
      <div className="navbar-logo">ClicqnConnect</div>
      <ul className="navbar-links largeScreen">
        <li>
          <a
            href="#"
            className={activeLink === 'join' ? 'active' : ''}
            onClick={() => {
              handleLinkClick('join')
              setShowJoinMeetingPop(true);
            }}
          >
            Join Meeting
          </a>
        </li>
        <li>
          <a
            href="#"
            className={activeLink === 'schedule' ? 'active' : ''}
            onClick={(e) => {
              handleLinkClick('schedule')
              setShowSchedulePop(true);
            }}
          >
            Schedule Meeting
          </a>
        </li>
        <li className="dropdown">
          <button className="dropdown-toggle">
            Features <FaChevronDown />
          </button>
          <ul className="dropdown-menu">
            <li>Audio Call</li>
            <li>Video Call</li>
            <li>Screen Share</li>
          </ul>
        </li>
        <li>
          <a
            href="#"
            className={activeLink === 'contact' ? 'active' : ''}
            onClick={() => handleLinkClick('contact')}
          >
            Contact Us
          </a>
        </li>
        <li>
          <a
            href="#"
            className={activeLink === 'signin' ? 'active' : ''}
            onClick={() => {
              handleLinkClick('signin');
              setShowLoginPopup(true);
            }}
          >
            Sign In
          </a>
        </li>
        <li>
          <a
            href="#"
            className={`freeWrap ${activeLink === 'signup' ? 'active' : ''}`}
           onClick={() => {
              handleLinkClick('signup');
              setShowLoginPopup(true);
            }}
          >
            Sign Up Free
          </a>
        </li>
        <li>
          <a
            className={`freeWrap ${activeLink === 'logout' ? 'active' : ''}`}
            onClick={(e) => {
              handleLinkClick('logout')
              localStorage.removeItem("user")
              window.location.href = "/home"
            }}
          >
            Logout {getUserName() || ""}
          </a>
        </li>
      </ul>

      <div className="hamburger" onClick={toggleSidebar}>
        <FaBars />
      </div>

      {/* Sidebar for mobile */}
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="close-icon" onClick={closeSidebar}><FaTimes /></div>
        <ul>
          <li><a href="#" className={activeLink === 'join' ? 'active' : ''} onClick={() => handleLinkClick('join')}>Join Meeting</a></li>
          <li><a href="#" className={activeLink === 'schedule' ? 'active' : ''} onClick={() => handleLinkClick('schedule')}>Schedule Meeting</a></li>
          <li>
            <details>
              <summary>Features <FaChevronDown /></summary>
              <ul className="sidebar-submenu">
                <li><a href="#" onClick={closeSidebar}>Audio Call</a></li>
                <li><a href="#" onClick={closeSidebar}>Video Call</a></li>
                <li><a href="#" onClick={closeSidebar}>Screen Share</a></li>
              </ul>
            </details>
          </li>
          <li><a href="#" className={activeLink === 'contact' ? 'active' : ''} onClick={() => handleLinkClick('contact')}>Contact Us</a></li>
          <li><a href="#" className={activeLink === 'signin' ? 'active' : ''} onClick={() => handleLinkClick('signin')}>Sign In</a></li>
          <li><a href="#" className={`freeMobile ${activeLink === 'signup' ? 'active' : ''}`} onClick={() => handleLinkClick('signup')}>Sign Up Free</a></li>
        </ul>
      </div>

      {sidebarOpen &&
        <div className="overlay" onClick={closeSidebar}>
        </div>
      }
      {showSchedulePop &&
        <ScheduleComponent showSchedulePopup={true} closeSchedulePopup={closeSchedulePopup} />
      }
      {showJoinMeetingPop &&
        <JoinMeetingComponent showJoinMeetingPop={true} closeJoinMeetingPop={closeJoinMeetingPop} />
      }
      <PopupModal
        isOpen={showLoginPopup}
        onClose={(e) => setShowLoginPopup(false)}
      >
        <Login
          tabName={activeLink}
          onClose={(e) => setShowLoginPopup(false)} />
      </PopupModal>
    </nav>
  );
};

export default Navigationbar;